import { translate } from '../../../Internationalization';

const headerKeyList = [
	'vendor_name',
	'vendor_category',
	'vendor_desc',
	'vendor_zip',
	'status',
	'edit',
];

/** @returns {{title: string}[]} */
export default function getVendorsTableHeader() {
	return headerKeyList.map((key) => ({
		title: translate(`agent.pages.offers.view.table.${key}`),
	}));
}
